import { AgGridService } from "@topline/services/agGridService";
import { Gen } from "../../../Services/api";
import { ApiClient } from "@topline/services/apiService";

interface FilterParams {
    page: number;
    pageSize: number;
    pharmacyMarket: string;
    molecules: { name: string }[];
    atc3: string;
    atc4: string;
    nfc3?: { fullName: string }[];
    brand: string;
    sku: string;
    skipSkusIds: number[];
    perscirptionMarket: string;
    sortField: string;
    sortType: string;
    moleculeType: string;
    onlySelectedMolecues: boolean;
}

export class ImsPolandMarketDataProvider {
    static componentName = "ImsPolandMarketDataProvider";
    static $inject = ["$q", AgGridService.componentName, ApiClient.componentName];

    constructor(protected $q: ng.IQService, protected agGridService: AgGridService, protected apiClient: ApiClient) {}

    getBrands(filterParams: FilterParams) {
        return this.apiClient
            .getIMSBrands({
                page: filterParams.page,
                pageSize: filterParams.pageSize,
                pharmacyMarket: filterParams.pharmacyMarket,
                molecules: filterParams.molecules.map(function (x) {
                    return x.name;
                }),
                atc3: filterParams.atc3,
                atc4: filterParams.atc4,
                nfc3: filterParams.nfc3 ? filterParams.nfc3.map(x => x.fullName) : [],
                brand: filterParams.brand,
                sku: filterParams.sku,
                skipSkusIds: filterParams.skipSkusIds,
                perscirptionMarket: filterParams.perscirptionMarket,
                sortField: filterParams.sortField,
                sortType: filterParams.sortType,
                moleculeType: filterParams.moleculeType,
                onlySelectedMolecues: filterParams.onlySelectedMolecues
            })
            .then(function (response) {
                return response;
            });
    }

    createBrandsDataSource = (filterConfig: any) => {
        return this.agGridService.createDataSource(this.getBrands.bind(this), filterConfig);
    };

    loadPharmacyMarkets() {
        return this.apiClient.getPharmacyMarkets();
    }

    loadPerscirptionMarket() {
        return this.apiClient.getPrescriptionMarket();
    }

    findAtc3(searchString: string) {
        return this.apiClient.getAtc3(searchString);
    }

    findMolecule(searchString: string) {
        return this.apiClient.getMolecues(searchString);
    }

    loadMoleculeType() {
        return this.apiClient.getMoleculeType();
    }

    findNfc3(searchString: string, molecules: string[]) {
        return this.apiClient.getNfc3(searchString, molecules);
    }

    loadAtc4(atc3: string) {
        return this.apiClient.getAtc4(undefined, atc3);
    }
}

angular.module("topline.modules").service(ImsPolandMarketDataProvider.componentName, ImsPolandMarketDataProvider);
